import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initWebVitals } from "./lib/webVitals";

async function clearLegacyAssetCaches() {
  if (typeof window === 'undefined' || !('caches' in window)) return;

  const legacyCacheNames = ['vendor-chunks'];
  await Promise.all(legacyCacheNames.map((cacheName) => caches.delete(cacheName)));
}

function refreshServiceWorkerRegistration() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      void registration.update();
    });
  });
}

// Initialize Web Vitals reporting to GA4
initWebVitals();

void clearLegacyAssetCaches();
refreshServiceWorkerRegistration();

// Global chunk failure recovery — handles stale cached chunks after deploy
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Loading chunk') ||
    event.message?.includes('ChunkLoadError')
  ) {
    if (!sessionStorage.getItem('chunk_reload_attempted')) {
      sessionStorage.setItem('chunk_reload_attempted', 'true');
      window.location.reload();
    }
  }
});

// Clear the reload flag on successful load
sessionStorage.removeItem('chunk_reload_attempted');

createRoot(document.getElementById("root")!).render(<App />);
